import { render, staticRenderFns } from "./CreateBillingAddress.vue?vue&type=template&id=64fb10f8&"
import script from "./CreateBillingAddress.vue?vue&type=script&lang=js&"
export * from "./CreateBillingAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports